import React from "react";
import { useNavigate } from "react-router-dom";

import InfoIcon from "@mui/icons-material/Info";

export default function FormErrorMessage(props) {
  const errorMsg = props.errorMsg;
  const showContactSupport = props.showContactSupport;

  const color = props.color || "text-red-400";

  const navigator = useNavigate();

  return (
    <div className="flex flex-row gap-2 mt-2">
      <div
        className={` ${color}  text-xs flex flex-col justify-center h-full `}
      >
        <InfoIcon fontSize="small" />
      </div>
      <div className="flex my-auto h-full  ">
        <p className={`${color} text-xs font-semibold `}>
          {errorMsg}

          {showContactSupport && (
            <>
              {" Please contact "}
              <a
                className="breadcrumb-text-active hover:cursor-pointer hover:underline"
                onClick={() => navigator("/knowledge-base-and-support")}
              >
                Support
              </a>
              {" for help"}
            </>
          )}
        </p>
      </div>
    </div>
  );
}
